export const USER_STATUS = {
    active: 0,
    frozen: 1,
    deleted: 2,
    blocked: 3
};

